import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-loaders',
  templateUrl: './loaders.component.html',
  styleUrl: './loaders.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LoadersComponent {

}
